module.exports = __webpack_public_path__ + "img/silvana-russo.3b11c2e2.jpg";